import { writable } from 'svelte/store'

export const site = writable({
  code: 'sunvairgroup',
  name: 'Sunvair Aerospace Group',
  address: {
    street: "29145 The Old Road",
    city: "Valencia",
    state: "CA",
    postal_code: "91355",
    country: "USA",
  },
  phone: "+1.661.294.3777",
  logo: '/img/sunvairgroup/logo.svg',
  color: {
    // primary and logo
    primary: '#0080d0',
    link: '#00a9ff',
  },
  navs: [
    {label: 'About', url: '/about', sub_background: '/img/fly.jpg', subs: [
      {label: 'Overview', url: '/about#overview'},
      {label: 'Leadership', url: '/about#leadership'},
      {label: 'Quality', url: '/about#quality'},
      {label: 'History', url: '/about#history'},
      {label: 'Environment', url: '/about#environment'},
    ]},
    {label: 'MRO Services', url: '/services', sub_background: '/img/gear-detail.jpg', subs: [
      {label: 'Fleets', url: '/services#fleets'},
      {label: 'Avionics', url: '/services#avionics'},
      {label: 'Instruments', url: '/services#instruments'},
      {label: 'Landing Gear', url: '/services#landing_gear'},
      {label: 'Plating & Surfaces', url: '/services#plating_surfaces'},
    ]},
    {label: 'Facilities', url: '/facilities'},
    {label: 'Customers', url: '/customers'},
    {label: 'Contact', url: '/contact'},
  ],
  home: {
    carousel: [
      {title: 'A TRADITION OF EXCELLENCE', url: '/about#history', img: '/img/reliability.jpg', body: 'Proudly serving the aerospace & defense industries for 65 years.'},
      {title: 'QUALITY & SERVICE', url: '/about#quality', img: '/img/reliability.jpg', body: 'SUNVAIR AEROSPACE GROUP delivers quality and world-class service to airlines all over the world.'},
      {title: 'INTERNATIONALLY RECOGNIZED', url: '/services', img: '/img/boeing.jpg', body: 'Award winning global services'},
      {title: 'OUR CORE VALUES', url: '/about#values', img: '/img/boeing.jpg', body: 'Safety. Satisfaction. Process. Accountability. Delivering reliability since 1955.'},
    ]
  },
  company: {
    intro: "Sunvair Aerospace Group is a leading provider of MRO services, bringing together the expertise of three specialty FAA repair stations",
    list: [
      {name: "Sunvair", tagline: "North America's premiere landing gear overhaul company", logo_mono: "/img/sunvair/logo-white.svg", logo: "/img/sunvair/logo.svg", url: "https://sunvair.aero/",
        code: "sunvair",
        email: "sales@sunvair.com",
        phone: "+1-661-294-3777",
        address: {
          street: "29145 The Old Road",
          city: "Valencia",
          state: "CA",
          postal_code: "91355",
          country: "USA",
        },
        map_url: ""
      },
      {name: "AAIC", tagline: "Global leader in avionics, instruments, and accessories MRO services", logo_mono: "/img/aaic/logo-white.svg", logo: "/img/aaic/logo.svg", url: "https://aaic.aero/",
        //code: "aaic",
        email: "sales@aaic.aero",
        phone: "+1-516-868-7700",
        address: {
          street: "210 Hanse Avenue",
          city: "Freeport",
          state: "NY",
          postal_code: "11520",
          country: "USA",
        },
        map_url: ""
      },
      {name: "Aerospace Plating", tagline: "Built to meet OEM's strictest plating requirements", logo_mono: "/img/aerospace_plating/logo-white.svg", logo: "/img/aerospace_plating/logo.svg", url: "https://aerospaceplating.com/",
        code: "aerospaceplating",
        email: "sales@aerospaceplating.com",
        phone: "+1-661-294-3777",
        address: {
          street: "29145 The Old Road",
          city: "Valencia",
          state: "CA",
          postal_code: "91355",
          country: "USA",
        },
        map_url: ""
      },
    ],
  },
  commitments: {
    title: "Our commitments to our customers, employees, and vendors",
    intro: "As part of the Sunvair Aerospace Group, our companies gain the benefit of collective resources, customers, and best practices and share a commitment to:",
    list: [
      {text: "The safety of our employees and our customers' passengers above all else.", icon: "fas fa-user-shield", color: "#323232"},
      {text: "The highest quality and reliability to maximize on-wing time.", icon: "fas fa-plane-departure", color: "#0080d0"},
      {text: "Excellence in customer service with 24/7 AOG and real-time communications.", icon: "fas fa-comments", color: "#d00080"},
      {text: "Finding innovative solutions to solve your most complex issues.", icon: "fas fa-lightbulb-on", color: "#ffbc00"},
      //{text: "Valuing and rewarding accoutability, which means, say what you do and do what you say.", icon: "fas fa-clipboard-check"},
      {text: "Upholding the highest environmental standards in the industry.", icon: "fas fa-leaf", color: "#80d000"},
    ]
  },
  division: {
    background: "/img/reliability.jpg",
    background_default: "/img/reliability.jpg",
    list: [
      {
        name: "Sunvair",
        intro: "The highest quality landing gear overhaul services",
        img: "/img/anet-1016420.jpg",
        logo: "/img/sunvair/logo-white.svg",
        logo_width: "40%",
        description: "Sunvair leverages data, technology and aviation expertise to deliver the highest quality and most reliable landing gear maintenance, repair, and overhaul service to keep our customers flying safely.",
        href: "https://www.sunvair.aero/",
        open: false,
      },
      {
        name: "AAIC",
        intro: "Exacting avionics and instruments repair services",
        img: "/img/fly.jpg",
        logo: "/img/aaic/logo-white.svg",
        logo_width: "30%",
        description: "Providing the highest level of service to customers in the avionics, accessories and instruments industry.  While superior service is our mission, the value we provide is in finding repairs to parts the that have had only expensive replacement options in the past.",
        href: "https://www.aaic.aero/",
        open: false,
      },
      {
        name: "Aerospace Plating",
        intro: "Advanced surface and plating services",
        img: "/img/inner-axel.jpg",
        logo: "/img/aerospaceplating/logo-white.svg",
        logo_width: "30%",
        description: "State of the art plating services to meet the highest level of OEM specifications and environmental responsibility.",
        href: "https://www.aerospaceplating.com/",
        open: false,
      }
    ],
  },
  values: {
    title: "Our values drive our reliability",
    list: [
      {title: "Safety", body: "Safety of our employees and our customers' passengers above all else.  Only by putting people first can we deliver on our job of providing innovative, quality repairs that keep our customers' aircraft flying safely and reliability."},
      {title: "Satisfaction", body: "We are laser focused on customer satisfaction as measured by warranty rate, turn time, and on time delivery.  Customers seek us out because we deliver unparalleled customer support and service, and they trust us because we provide unfettered access to our people and timely responses."},
      {title: "Process", body: "We constantly look for opportunities to improve our process and expand our capabilities.   Our innovative solution orientation enables us to deliver unique and proprietary repairs that solve our customers' most complex problems.  We look to the individual, the team, and the company to always get better and never stand still."},
      {title: "Accountability", body: "Accountability means you say what you'll do and do what you say, and everyone here is accountable.  We leverage communication at every level to build confidence and trust both internally and externally.  We are committed to always keeping our customers highly informed."}
    ]
  },
  footer: {
    sections: [
      {title: "Overhaul Services", links: [
        {name: "Landing Gear", url: "/services#landing-gear"},
        {name: "Avionics & Instruments", url: "/services#avionics"},
        {name: "Hydraulics", url: "/services#hydraulics"},
        {name: "Accessories", url: "/services#accessories"},
      ]},
      {title: "Support", links: [
        {name: "Customer Portal", url: "https://theaero.com/status/hub"},
        {name: "Operations", url: "/operations"},
        {name: "Employees", url: "/employees"},
        {name: "Technical Support", url: "/support"},
      ]},
      {title: "Company Info", links: [
        {name: "Careers", url: "/careers"},
        {name: "Company", url: "/about"},
        {name: "Certificates", url: "/certifications"},
        {name: "Investors", url: "/investors"},
      ]},
      {title: "How Can We Help?", links: [
        {name: "Contact Us", url: "/contact"},
        {name: "Get a Quote", url: "/contact?subject=Request+for+Quote"},
        {name: "Job Status", url: "https://theaero.com/status/hub"},
        {name: "Records / 8130", url: "https://theaero.com/status/hub"},
      ]},
      {title: "News & Events", links: [
        {name: "News", url: "/news"},
        {name: "Customer Stories", url: "/customer/stories"},
        {name: "Press Kit", url: "/press/kit"},
        {name: "Trade Shows & Events", url: "/events"},
      ]},
    ],
    social: {
      linkedin_link: '#',
      twitter_link: '#'
    }
  },
  rfq: {
    categories: [
      "Accessories",
      "Avionics",
      "Hydraulics",
      "Instruments",
      "Landing Gear",
      "Plating"
    ]
  }
})
